// extracted by mini-css-extract-plugin
export default {"container":"contact-item_container__Rwzvz","text":"contact-item_text__le1f8","link":"contact-item_link__UYt7B"};